import { render, staticRenderFns } from "./banner-stand-order-modal.vue?vue&type=template&id=073365f2"
import script from "./banner-stand-order-modal.vue?vue&type=script&lang=ts"
export * from "./banner-stand-order-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports